jQuery(function($) {
    function refreshCart() {
        $.ajax({
            url: perf_cart_refresh.ajaxurl,
            type: 'POST',
            data: {
                action: 'refresh_cart_after_shipping_change',
                security: perf_cart_refresh.nonce
            },
            beforeSend: function() {
                $('.woocommerce-cart-form').addClass('loading');
            },
            success: function(response) {
                if (response.success) {
                   $('.woocommerce-cart-form').replaceWith(response.data.cart_html);
                    $('div#offcanvasCart .offcanvas-body').html(response.data.mini_cart_html);

                    $('.woocommerce-notices-wrapper').each(function() {
                        // 1️⃣ Rimuove tutti i notice del coupon dinamico dentro ogni wrapper
                        $(this).find('.notice-dynamic-coupon').closest('.alert-success').remove();
                        $(this).find('.notice-choose-ritiro').closest('.alert-primary').remove();

                        // 2️⃣ Aggiunge il nuovo notice restituito dal server (se esiste)
                        if (response.data.notice) {
                            $(this).append(response.data.notice);
                        }
                    });

                    // Trigger standard WooCommerce per ricalcolo totale
                    $(document.body).trigger('updated_wc_div');
                } else {
                    console.error(response.data);
                }
            },
            complete: function() {
                $('.woocommerce-cart-form').removeClass('loading');
            }
        });
    }

    // ✅ Metodo WooCommerce ufficiale
    $(document.body).on('updated_shipping_method', function() {
        refreshCart();
    });

    // fallback: se il radio cambia e l'evento non parte
    // $(document).on('change', 'input[name^="shipping_method"]', function() {
    //     console.log('sebaaa')
    //     refreshCart();
    // });
});

